<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="12">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Clientes</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Clientes Finais da Termometria</h1>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-button style = "float: left; margin-left: 10px;" type="primary" @click="adicionarCliente" icon="el-icon-circle-plus-outline">
          Novo
        </el-button>
      </el-col>
    </el-row>

    <br/>
    
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="clientes"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Carregando..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
          striped
          :sort-change="handleSortChange"
          :default-sort="{ prop: 'nome', order: 'ascending' }"
        >
          <el-table-column prop="sge_cliente" label="Fabricante" width="95">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getFabricanteTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.sge_cliente }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sge_cliente" label="Vendedor" width="85">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getUsuarioTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.users_id }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="nome" label="Nome" min-width="300" sortable></el-table-column>
          <el-table-column prop="cpfcnpj" label="CPF/CNPJ" min-width="150" sortable></el-table-column>
          <el-table-column prop="logradouro" label="Logradouro" width="320" sortable></el-table-column>
          <el-table-column prop="bairro" label="Bairro" width="200" sortable></el-table-column>
          <el-table-column prop="cidade" label="Cidade" width="200" sortable></el-table-column>
          <el-table-column prop="estado" label="UF" width="65" sortable></el-table-column>
          <el-table-column prop="cep" label="CEP" width="90" sortable></el-table-column>
          <el-table-column prop="email" label="Email" width="220" sortable></el-table-column>
          <el-table-column prop="telefone" label="Telefone" width="125" sortable></el-table-column>
          <el-table-column label="Ações" width="200">
            <template v-slot="{ row }">
              <el-button 
                size="mini" 
                type="primary" 
                icon="el-icon-edit"
                @click="editarCliente(row)" 
                title="Editar Registro"
              >Editar</el-button>
              <el-button 
                size="mini" 
                type="danger" 
                icon="el-icon-delete"
                @click="confirmarExclusao(row.id)" 
                title="Excluir Registro"
              >Excluir</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next"
      :total="total"
    ></el-pagination>

    <!-- Modal cliente -->
    <el-dialog title="Cliente" :visible.sync="formClienteVisible">
      <el-form ref="form" :model="cliente" :rules="rules" label-width="120px">
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="cliente.nome"></el-input>
        </el-form-item>
        <el-form-item label="CPF/CNPJ" prop="cpfcnpj">
          <el-input v-model="cliente.cpfcnpj" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="Logradouro" prop="logradouro">
          <el-input v-model="cliente.logradouro"></el-input>
        </el-form-item>
        <el-form-item label="Bairro" prop="bairro">
          <el-input v-model="cliente.bairro"></el-input>
        </el-form-item>
        <el-form-item label="Cidade" prop="cidade">
          <el-input v-model="cliente.cidade"></el-input>
        </el-form-item>
        <el-form-item label="Estado" prop="estado">
          <el-input 
            v-model="cliente.estado" 
            maxlength="2" 
            @input="cliente.estado = cliente.estado.toUpperCase().slice(0, 2)">
          </el-input>
        </el-form-item>
        <el-form-item label="CEP" prop="cep">
          <el-input v-model="cliente.cep" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="cliente.email"></el-input>
        </el-form-item>
        <el-form-item label="Telefone" prop="telefone">
          <el-input v-model="cliente.telefone" maxlength="15"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="formClienteVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="salvarCliente">Salvar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      clientes: [],
      cliente: {},
      permissao: {},
      usuario: null,
      formClienteVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      sortBy: 'nome',
      sortOrder: 'asc',
      rules: {
        nome: [
          { required: true, message: 'Por favor, insira o nome', trigger: 'blur' },
          { min: 3, message: 'O nome deve ter pelo menos 3 caracteres', trigger: 'blur' }
        ],
        email: [{ type: 'email', message: 'Email inválido', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.usuario = FuncoesUteis.getUsuario();
    this.usuario = this.usuario.id_usuario || 0;
    this.getDados()
  },
  methods: {
    async getDados() {
      this.loading = true;
      try {
        const response = await axios.get(`${url}/termometria-cliente-paginado?page=${this.currentPage}&perPage=${this.pageSize}&sortBy=${this.sortBy}&sortOrder=${this.sortOrder}`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.clientes = response.data.data;
          // console.log("Clientes:", this.clientes);
          this.total = response.data.total;
        }
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      } finally {
        this.loading = false;
      }
    },
    getFabricanteTooltip(row) {
      return row.fabricante?.razao_social || '—';
    },
    getUsuarioTooltip(row) {
      return row.usuario?.nome || '—';
    },
    async salvarCliente() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.cliente.id) {
              response = await axios.put(url + '/termometria-cliente/' + this.cliente.id, this.cliente, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Cliente atualizado com sucesso!');
            } else {
              response = await axios.post(url + '/termometria-cliente', this.cliente, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Cliente salvo com sucesso!');
            }
            if (response.data.status === "Token is Expired") {
              await this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              this.getDados();
              this.formClienteVisible = false;
            }
          } catch (error) {
            console.error('Erro ao salvar/atualizar cliente:', error);
            this.$message.error('Erro ao salvar/atualizar cliente. Por favor, tente novamente.');
          }
        } else {
          // console.log('Erro na validação do formulário.');
          this.$message.error('Por favor, corrija os erros no formulário.');
          return false;
        }
      });
    },
    adicionarCliente() {
      this.cliente = {
        id: null,
        nome: "",
        cpfcnpj: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
        email: "",
        telefone: "",
      };
      this.formClienteVisible = true;
    },
    editarCliente(cliente) {
      this.cliente = { ...cliente };
      this.formClienteVisible = true;
    },
    confirmarExclusao(id) {
      this.$confirm(
        "Tem certeza de que deseja excluir este cliente?",
        "Confirmação",
        {
          confirmButtonText: "Excluir",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          this.excluirCliente(id);
        })
        .catch(() => {
          this.$message({
              type: 'info',
              message: 'Exclusão cancelada!'
            });
        });
    },
    async excluirCliente(id) {
      try {
        await axios.delete(url + "/termometria-cliente/" +id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        this.$message({
          type: 'success',
          message: 'Cliente excluído com sucesso!'
        });
        this.getDados();
      } catch (err) {
        console.error("Erro ao excluir cliente:", err);
        this.$message({
          type: 'error',
          message: 'Erro ao excluir cliente!'
        });
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getDados();
    },
    handleSortChange(column) {
      this.sortBy = column.prop;
      this.sortOrder = column.order === 'ascending' ? 'asc' : 'desc';
      this.fetchData();
    },
  },
};
</script>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>
